"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KahbaStateStorageBatchingStrategy = exports.KahbaRuntimeStateStoreType = exports.BeginKahbaScriptOriginType = exports.KahbaRuntimeStatus = void 0;
var KahbaRuntimeStatus;
(function (KahbaRuntimeStatus) {
    KahbaRuntimeStatus["Starting"] = "Starting";
    KahbaRuntimeStatus["Running"] = "Running";
    KahbaRuntimeStatus["Suspended"] = "Suspended";
    KahbaRuntimeStatus["Done"] = "Done";
    // tbd:
    KahbaRuntimeStatus["Finishing"] = "Finishing";
    KahbaRuntimeStatus["Aborted"] = "Aborted";
    KahbaRuntimeStatus["WranggleInternalError"] = "WranggleInternalError";
})(KahbaRuntimeStatus = exports.KahbaRuntimeStatus || (exports.KahbaRuntimeStatus = {}));
var BeginKahbaScriptOriginType;
(function (BeginKahbaScriptOriginType) {
    BeginKahbaScriptOriginType["ApiRequest"] = "ApiRequest";
    BeginKahbaScriptOriginType["KahbaScript"] = "KahbaScript";
    BeginKahbaScriptOriginType["RepeatRun"] = "RepeatRun";
    BeginKahbaScriptOriginType["DevDraft"] = "DevDraft";
    BeginKahbaScriptOriginType["OrgAdminForcing"] = "OrgAdminForcing";
})(BeginKahbaScriptOriginType = exports.BeginKahbaScriptOriginType || (exports.BeginKahbaScriptOriginType = {}));
var KahbaRuntimeStateStoreType;
(function (KahbaRuntimeStateStoreType) {
    KahbaRuntimeStateStoreType["Memory"] = "Memory";
    KahbaRuntimeStateStoreType["RedisOptimistic"] = "RedisOptimistic";
})(KahbaRuntimeStateStoreType = exports.KahbaRuntimeStateStoreType || (exports.KahbaRuntimeStateStoreType = {}));
var KahbaStateStorageBatchingStrategy;
(function (KahbaStateStorageBatchingStrategy) {
    /**
     * When set to Hardier, each task/workflow will wait for writes to complete before continuing.
     */
    KahbaStateStorageBatchingStrategy["Hardier"] = "Hardier";
    /**
     * When set to Faster, writes are done in the background, the task/workflow does not wait, with subsequent ones accessing the
     * latest state from memory. Should the process crash (or have trouble with suspend) the state when resumed would be inaccurate,
     * most likely resulting in repeated tasks but potentially in unexpected bugs.
     *
     */
    KahbaStateStorageBatchingStrategy["Faster"] = "Faster";
})(KahbaStateStorageBatchingStrategy = exports.KahbaStateStorageBatchingStrategy || (exports.KahbaStateStorageBatchingStrategy = {}));
//# sourceMappingURL=kahba-runtime-descriptor.js.map